export function login(token, rememberMe = false) {
  if (rememberMe) {
    localStorage.setItem('token', token);
  } else {
    sessionStorage.setItem('token', token);
  }
}

export function getToken() {
  return localStorage.getItem('token') || sessionStorage.getItem('token');
}

export function setToken(token) {
  if (localStorage.getItem('token')) {
    localStorage.setItem('token', token);
  } else if (sessionStorage.getItem('token')) {
    sessionStorage.setItem('token', token);
  }
}

export function logout() {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('season');
}



// WEBPACK FOOTER //
// ./src/lib/auth.js